"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-76331d1c"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "header-layout" };
var _hoisted_2 = { class: "header-left-layout" };
var _hoisted_3 = { class: "header-right-layout" };
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var element_plus_1 = require("element-plus");
var core_1 = require("@vueuse/core");
var index_1 = require("@/store/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'HeaderComponent',
    setup: function (__props) {
        var mainStore = (0, index_1.useMainStore)();
        var isDark = (0, core_1.useDark)();
        var router = (0, vue_router_1.useRouter)();
        var outLogin = function () {
            element_plus_1.ElMessageBox.confirm('是否注销本次登录并清空所有登录信息?', '注销提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(function () {
                router.push({ path: "/login" });
                (0, element_plus_1.ElMessage)({
                    type: 'success',
                    message: '登录信息已注销，已完成退出',
                });
                var removeItemList = ["user_data", "token"];
                removeItemList.forEach(function (item) {
                    localStorage.removeItem(item);
                });
            });
        };
        var toggle = (0, core_1.useFullscreen)().toggle;
        var route = (0, vue_router_1.useRoute)();
        var userData = (0, vue_3.ref)({ user_name: "XXXX", user_account: "XXXX" });
        if (userData.value.user_name == 'XXXX') {
            setTimeout(function () {
                var userinfo = localStorage.getItem("user_data");
                userData.value = userinfo && userinfo !== 'undefined' ? JSON.parse(userinfo) : { user_name: "XXXX", user_account: "XXXX" };
            }, 200);
        }
        var pathArr = [];
        route.matched.forEach(function (item) {
            var meta = item.meta;
            var path = item.path;
            if (meta.parentPath && meta.parent) {
                pathArr.push({ path: meta.parentPath, title: meta.parent });
            }
            pathArr.push({ path: path, title: meta.title });
        });
        var routerArr = (0, vue_3.ref)(pathArr);
        (0, vue_3.watch)(route, function (next, _) {
            var tempArr = [];
            next.matched.forEach(function (item) {
                var meta = item.meta;
                var path = item.path;
                if (meta.parentPath && meta.parent) {
                    tempArr.push({ path: meta.parentPath, title: meta.parent });
                }
                tempArr.push({ path: path, title: meta.title });
            });
            routerArr.value = tempArr;
        });
        return function (_ctx, _cache) {
            var _component_Expand = (0, vue_2.resolveComponent)("Expand");
            var _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            var _component_Fold = (0, vue_2.resolveComponent)("Fold");
            var _component_el_breadcrumb_item = (0, vue_2.resolveComponent)("el-breadcrumb-item");
            var _component_el_breadcrumb = (0, vue_2.resolveComponent)("el-breadcrumb");
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_FullScreen = (0, vue_2.resolveComponent)("FullScreen");
            var _component_el_switch = (0, vue_2.resolveComponent)("el-switch");
            var _component_SwitchButton = (0, vue_2.resolveComponent)("SwitchButton");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "trigger",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            function () {
                                var _a;
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return ((0, vue_2.unref)(mainStore).onTrigger && (_a = (0, vue_2.unref)(mainStore)).onTrigger.apply(_a, args));
                            })
                    }, [
                        ((0, vue_2.unref)(mainStore).isCollapse)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_icon, {
                                key: 0,
                                class: "icon"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_Expand)
                                ]; }),
                                _: 1
                            }))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_icon, {
                                key: 1,
                                class: "icon"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_Fold)
                                ]; }),
                                _: 1
                            }))
                    ]),
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createVNode)(_component_el_breadcrumb, { "separator-icon": "ArrowRight" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(vue_2.TransitionGroup, { name: "list" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(routerArr), function (item) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_breadcrumb_item, {
                                                key: item.path,
                                                to: item.path
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.title), 1)
                                                ]; }),
                                                _: 2
                                            }, 1032, ["to"]));
                                        }), 128))
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createVNode)(_component_el_button, {
                        class: "right-icon",
                        icon: "User",
                        onClick: _cache[1] || (_cache[1] = function ($event) { return ((0, vue_2.unref)(router).push({ path: '/user-center' })); })
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(userData).user_account) + " / " + (0, vue_2.toDisplayString)((0, vue_2.unref)(userData).user_name), 1)
                        ]; }),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_el_icon, {
                        onClick: (0, vue_2.unref)(toggle),
                        class: "icon right-icon"
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_FullScreen)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"]),
                    (0, vue_2.createVNode)(_component_el_switch, {
                        class: "right-icon",
                        size: "large",
                        onChange: _cache[2] || (_cache[2] = function ($event) { return ((0, vue_2.unref)(mainStore).changeTheme()); }),
                        style: { "--el-switch-on-color": "#2c2c2c", "--el-switch-off-color": "#f2f2f2" },
                        modelValue: (0, vue_2.unref)(isDark),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((0, vue_2.isRef)(isDark) ? (isDark).value = $event : null); }),
                        "inline-prompt": "",
                        "active-action-icon": "Moon",
                        "inactive-action-icon": "Sunny"
                    }, null, 8, ["modelValue"]),
                    (0, vue_2.createVNode)(_component_el_icon, {
                        onClick: outLogin,
                        class: "icon right-icon"
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_SwitchButton)
                        ]; }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
